var map = {
	"./index.js": 88,
	"./messages.js": 310,
	"./notifications.js": 311,
	"./products.js": 312,
	"./tasks.js": 313,
	"./user.js": 314
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 955;


//////////////////
// WEBPACK FOOTER
// ./src/vuex/modules nonrecursive \.js$
// module id = 955
// module chunks = 0